(function () {
    angular.module('pages.tabbedContent', [])
        .controller('tabbedContentController', tabbedContentController);

    /**
     * @ngdoc controller
     * @name pages.scrolledContentController
     * @description
     * Controller used for scrolled content doc type.
     */
    tabbedContentController.$inject = ['$scope', '$location'];
    function tabbedContentController($scope, $location) {
        var tabs;
        $scope.reinitializeTabs = function () {
            tabs = angular.element('#section-tabs');
            new Foundation.Tabs(tabs);
        }

        var tabContent = angular.element('[data-tabs-content="section-tabs"]');
        var header = angular.element('.header');

        $scope.backToTop = function ($event) {
            console.log(tabContent.offset().top, header.height(), tabs.height());
            var shift = tabContent.offset().top - header.height() - tabs.height();
            if (shift < 0) {
                angular.element('#content').animate({
                    scrollTop: '+=' + shift
                }, 300);
            }
        }
    }
})();